<script lang="ts">
    export let amount: number;
</script>

<span class="money-amount"
      data-qa="user-finance-sum"
      class:negative={amount < 0}>{amount}Kč</span>

<style lang="less">
    .money-amount {
        color: var(--success-green);
        margin-left: auto;

        &.negative {
            color: var(--danger-red);
        }
    }
</style>